export const MigrosAppTheme = {
  name: 'Migros App Theme',
  themeId: 'migrosApp',
  fonts: {
    sizes: {
      text: {
        small: '17px'
      }
    }
  }
};